import React from 'react'
import styles from './BulkBundlePriceList.sass'

interface BulkBundlePriceListProps {
  /**
   * Label for the third column (e.g. "New price"), whose cell content each
   * `BundlePriceItem` supplies via `right`.
   */
  rightHeader: string
  children: React.ReactNode
}

/**
 * The bundle price list shared by the bulk pricing dialogs: a
 * "Bundle | Current price | <right>" header over a card per bundle. Consumers
 * render a `BundlePriceItem` per bundle so the right column stays theirs — a
 * projected price for discounts, an input for direct edits.
 */
export function BulkBundlePriceList({
  rightHeader,
  children,
}: BulkBundlePriceListProps) {
  return (
    <>
      <div className={styles.header}>
        <span className={styles.bundleCol}>Bundle</span>
        <span className={styles.priceCol}>Current price</span>
        <span className={styles.rightCol}>{rightHeader}</span>
      </div>

      <div className={styles.list}>{children}</div>
    </>
  )
}

interface BundlePriceItemProps {
  name: string
  currentPrice: number
  right: React.ReactNode
  dataTest?: string
}

export function BundlePriceItem({
  name,
  currentPrice,
  right,
  dataTest,
}: BundlePriceItemProps) {
  return (
    <div className={styles.row} data-test={dataTest}>
      <span className={styles.bundleName}>{name}</span>
      <span className={styles.currentPrice}>${currentPrice.toFixed(2)}</span>
      <div className={styles.rightCol}>{right}</div>
    </div>
  )
}
